<h2 mat-dialog-title>{{ data.title | translate }}</h2>
<mat-label>{{ data.text | translate }}</mat-label>
<mat-dialog-actions align="end">
  <button
    [disableRipple]="true"
    mat-raised-button
    color="accent"
    (click)="noHandleClick()"
  >
    {{ 'pages.timeDialog.functionMenu.no' | translate  }}
  </button>
  <button
    id="abbruch"
    color="accent"
    (click)="yesHandleClick()"
  >
    {{ 'pages.timeDialog.functionMenu.yes' | translate }}
  </button>
</mat-dialog-actions>
